module.exports = __webpack_public_path__ + "static/media/HCMM801.93e61a61.jpg";